import * as React from 'react';

// Context
import { BackgroundColorContext } from './context';

// Hooks
import { useResponsiveLayout, Layout } from '@shopee-user/layout-responsive';

// Types
import { BackgroundColorConfig } from './types';

export interface BackgroundColorContainerProps {
  children: React.ReactNode;
  defaultBackgroundColor: string;
  backgroundColorMobile: string;
  backgroundColorDesktop: string;
}

export function BackgroundColorContainer({
  children,
  defaultBackgroundColor,
  backgroundColorMobile,
  backgroundColorDesktop,
}: BackgroundColorContainerProps): JSX.Element {
  const [config, setConfig] = React.useState<BackgroundColorConfig>({
    mobile: backgroundColorMobile,
    desktop: backgroundColorDesktop,
  });
  const { layout } = useResponsiveLayout();

  React.useLayoutEffect(() => {
    if (document.body) {
      document.body.style.backgroundColor =
        layout === Layout.Desktop ? config.desktop : config.mobile;
    }

    return () => {
      if (document.body) {
        document.body.style.backgroundColor = defaultBackgroundColor;
      }
    };
  }, [config.desktop, config.mobile, layout, defaultBackgroundColor]);

  return (
    <BackgroundColorContext.Provider
      value={{ setBackgroundColorConfig: setConfig }}
    >
      {children}
    </BackgroundColorContext.Provider>
  );
}

export { BackgroundColorContext };

export { useBackgroundColor } from './hook';

export type { BackgroundColorConfig };
